export const featuredMembers = [
  {
    name: "Jag Kooner",
    role: "President",
    image: "/team/jagkooner.png",
  },
  {
    name: "James Ruberti",
    role: "Head Sales Team",
    image: "/team/james.png",
  },
  {
    name: "Sam Kang",
    role: "Vice President",
    image: "/team/samkang.png",
  },
];

export const departmentHeads = [
  {
    name: "Balwant Sidhu",
    role: "Head of Management (CA)",
    desc: "Oversees operations, aligning strategy, teams, and execution.",
    image: "/team/balwant.png",
  },
  {
    name: "Ron Sahota",
    role: "Head of Management (TX)",
    desc: "Leads company-wide operations and performance.",
    image: "/team/ron.png",
  },
  {
    name: "Kevin",
    role: "Fleet Maintenance Director",
    desc: "Oversees fleet reliability, maintenance, and compliance.",
    image: "/team/kevin.png",
  },
 /* {
    name: "Harpreet Singh",
    role: "Director of Operations",
    desc: "Oversees compliant, safe performance-driven dispatch operations.",
    image: "/team/harpreet.png",
  },*/
  {
    name: "Guillermo Alfaro",
    role: "Safety & HR Director",
    desc: "Leads safety, human resources, and driver recruitment.",
    image: "/team/alfaro.png",
  },
];

export const mechanics = [
  {
    name: "Jesse",
    role: "Senior Mechanic",
    desc: "20+ years of expertise in engine systems, drivetrains, braking, and fleet maintenance.",
    image: "/team/jesse.png",
  },
  {
    name: "Jesus",
    role: "Lead Heavy-Duty Mechanic",
    desc: "Well-known mechanic with over 15 years of hands-on experience in diagnostics, repairs, and preventive maintenance.",

    image: "/team/jesus.png",
  },
];

export const dispatchCali = ["Harsh", "Robin", "Karman", "Hardeep"];

export const dispatchTexas = ["Jai", "Joven", "Aditi", "Anchal"];

export const driverHiring = ["Aniket", "Nitika", "Kamal"];

export const safetyAndHOS = ["Dilpreet", "Lakhveer"];

export const billingAndPayroll = ["Harman", "Rinshu", "Sonal"];

export const trackingTeam = ["Harjot", "Manish Negi"];

export const afterHoursTeam = ["Manish", "Gagan"];
